export default __webpack_public_path__ + "static/media/bf.4275eb85.svg";